<template>
  <div
    @click="openDoc"
    :class="chiave % 2 === 0 ? 'row pari' : 'row'"
    class="align-items-center position-relative"
  >
    <div class="col-md-3 col-5 mobile">
      {{ trans.get("b2b.orders.document-no") }}
    </div>

    <div class="col-md-3 col-5">
      {{ n_ordine }}
    </div>

    <div class="col-md-2 col-lg-3 col-5 mobile mob-inv">
      {{ trans.get("b2b.orders.date") }}
    </div>

    <div class="col-md-2 col-lg-3 col-5 mob-inv">
      {{ parseDate }}
    </div>
    <div class="col-md-2 col-lg-3 col-5 mobile mob-inv">
      {{ trans.get("b2b.orders.status") }}
    </div>

    <div class="col-md-2 col-lg-3 col-5 mob-inv">
      <span v-if="stato_ordine" :class="'stato-ordine-' + stato_ordine.stato">{{ stato_ordine.testo }}</span>
    </div>
    <div class="col-md-5 col-lg-3 col-5 mobile mob-inv">
      {{ trans.get("b2b.orders.price") }}
    </div>

    <div class="col-md-5 col-lg-3 col-5 mob-inv">
      {{ totale_ordine.toLocaleString("it-IT", { minimumFractionDigits: 3 }) }}
      €
      <small
        >({{
          iva.toLocaleString("it-IT", { minimumFractionDigits: 3 })
        }}
        €)</small
      >
    </div>
    <img src="/media/icons/svg/caret-right-black.svg" alt="" />
  </div>
</template>

<script>
export default {
  name: "det-ordini",
  props: [
    "n_ordine",
    "id_ordine",
    "data_ordine",
    "ora_ordine",
    "stato_ordine",
    "totale_ordine",
    "iva",
    "chiave",
  ],
  computed: {
    parseDate: function () {
      let data = dayjs(this.data_ordine);

      return `${data.date()}-${data.month() + 1}-${data.year()}`;
    },
  },
  methods: {
    openDoc: function () {
      this.$emit("openDoc", {
        id_ordine: this.id_ordine,
        n_ordine: this.n_ordine,  // anno_registrazione-codSerie - NumRegistraz
        // ordine: this.n_ordine,
        data: this.data_ordine,
        stato: this.stato_ordine,
        importo: this.totale_ordine,
        iva: this.iva,
      });
    },
    emitDate: function () {
      let data = dayjs(this.data_ordine);
      let anno = data.year();

      this.$emit("year", anno);
      let mese = data.month();

      this.$emit("month", mese + 1);
      this.$emit("loaded", this.chiave);
    },
  },
  mounted() {
    this.emitDate();
  },
};
</script>

<style lang="scss" scoped>
.row {
  //height: 40px;
  padding-top: 10px;
  padding-bottom: 10px;
  &:hover {
    font-weight: bold;
  }
  .stato-ordine-1 {
    color: var(--dark-green);
  }
  .stato-ordine-0 {
    color: var(--dark-yellow);
  }
  .stato-ordine-2 {
    color: var(--purple);
  }
}
.row.pari {
  background-color: #f8f7f7;
}
img {
  position: absolute;
  right: 15px;
}
.mob-inv {
  display: none;
  &:hover {
    display: block;
  }
}

@media (min-width: 768px) {
  .mob-inv {
    display: block;
  }
  .mobile {
    display: none;
  }
}
</style>
